import { render, staticRenderFns } from "./editFeeCombo.vue?vue&type=template&id=53c035ac"
import script from "./editFeeCombo.vue?vue&type=script&lang=js"
export * from "./editFeeCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports